module.exports = __webpack_public_path__ + "assets/media/chat.aa791f20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookReadyStep/chat.svg
// module id = 3136
// module chunks = 0